import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/hmi_users',
    name: 'PUT_WORKER_USERS',
    method: 'PUT',
  });

  return [exec, isRequestSuccessed];
});
